module.exports = __webpack_public_path__ + "media/images/banner-assets/th/banner0-73df3fd2a6faafc63d118f55d7de61ed.jpg";